export default __webpack_public_path__ + "static/media/Asset192.2003a022.svg";